import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=134abcf4&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"
import style0 from "./slider.vue?vue&type=style&index=0&id=134abcf4&prod&lang=stylus&scoped=true"
import style1 from "./slider.vue?vue&type=style&index=1&id=134abcf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134abcf4",
  null
  
)

export default component.exports